import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
  Tooltip,
} from "@mui/material";
import VantageListHead from "../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
} from "../../../../component/Methods";
import { getValidatedTableStyles, getCellStyle } from "../../styles/rebalancerStyles";

const AfterOrder = ({ afterOrders, tableHeader }) => {
  const theme = useTheme();
  const styles = getValidatedTableStyles(theme);
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("strategy");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (afterOrders) {
      const formattedData = Object?.entries(afterOrders)?.map(
        ([strategy, positions]) => ({
          strategy,
          ...positions,
        })
      );
      const filteredUsers = applySortFilter(
        formattedData,
        getComparator(order, orderBy)
      );
      setData(filteredUsers);
    }
  }, [order, orderBy, afterOrders]);

  return (
    <>
      <Box sx={styles.section}>
        <Typography sx={styles.title}>
          Calculated Positions After Execution
        </Typography>

        <TableContainer sx={styles.tableContainer}>
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={styles.table}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow key={index} sx={styles.row}>
                  <Tablecell align="left" style={getCellStyle(theme, "left")}>
                    {row?.strategy}
                  </Tablecell>
                  <Tooltip
                    title={`Real: ${row?.starting?.real}, Cros: ${row?.starting?.cross}`}
                    arrow
                    PopperProps={{
                      sx: {
                        "& .MuiTooltip-tooltip": {
                          fontSize: "16px",
                          padding: "10px",
                        },
                      },
                    }}
                  >
                    <Tablecell align="right" style={getCellStyle(theme, "right")}>
                      {calculateAndFormatNoAbs(row?.starting?.net)}
                    </Tablecell>
                  </Tooltip>

                  <Tooltip
                    title={`Real: ${row?.orders?.real}, Cros: ${row?.orders?.cros}`}
                    arrow
                    PopperProps={{
                      sx: {
                        "& .MuiTooltip-tooltip": {
                          fontSize: "16px",
                          padding: "10px",
                        },
                      },
                    }}
                  >
                    <Tablecell align="right" style={getCellStyle(theme, "right")}>
                      {calculateAndFormatNoAbs(row?.orders?.net)}
                    </Tablecell>
                  </Tooltip>
                  <Tooltip
                    title={`Real: ${row?.ending?.real}, Cros: ${row?.ending?.cros}`}
                    arrow
                    PopperProps={{
                      sx: {
                        "& .MuiTooltip-tooltip": {
                          fontSize: "16px",
                          padding: "10px",
                        },
                      },
                    }}
                  >
                    <Tablecell align="right" style={getCellStyle(theme, "right")}>
                      {calculateAndFormatNoAbs(row?.ending?.net)}
                    </Tablecell>
                  </Tooltip>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default AfterOrder;
